import {createReducer} from '@reduxjs/toolkit';
import {selectFeatures, selectProduct} from '@src/actions/quotaReservations.ts';
import {type Feature} from '@src/types/featureCollections.ts';
import {type Product} from '@src/types/products.ts';

type QuotaReservationsState = {
  selectedFeatures: Feature[];
  selectedProduct: Product | null;
};

export const initialState: QuotaReservationsState = {
  selectedFeatures: [],
  selectedProduct: null,
};

export default createReducer(initialState, builder => {
  builder.addCase(selectFeatures, (state, {payload}) => {
    state.selectedFeatures = payload ?? [];
  });

  builder.addCase(selectProduct, (state, {payload}) => {
    state.selectedProduct = payload ?? null;
  });
});
